import React from 'react';
import { X } from 'lucide-react';

const Modal = ({ isOpen, onClose, title, children, size = 'md', placement = 'center', contentAlignCenter = false }) => {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl'
  };

  return (
    <div 
      className={`modal-overlay${placement === 'top-right' ? ' top-right' : ''}`}
      onClick={onClose}
    >
      <div 
        style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
          width: '100%',
          maxWidth: size === 'sm' ? '384px' : size === 'md' ? '512px' : size === 'lg' ? '672px' : '896px',
          maxHeight: '90vh',
          overflow: 'auto',
          display: contentAlignCenter ? 'flex' : 'block',
          flexDirection: contentAlignCenter ? 'column' : undefined,
          alignItems: contentAlignCenter ? 'center' : undefined,
          justifyContent: contentAlignCenter ? 'center' : undefined,
          padding: contentAlignCenter ? '24px' : undefined
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: contentAlignCenter ? 'center' : 'space-between',
          padding: '16px 24px',
          borderBottom: contentAlignCenter ? 'none' : '1px solid #e5e7eb',
          width: contentAlignCenter ? '100%' : undefined
        }}>
          {title && (
            <h2 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#111827',
              margin: 0
            }}>
              {title}
            </h2>
          )}
          <button
            onClick={onClose}
            style={{
              padding: '4px',
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              borderRadius: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: contentAlignCenter ? 'absolute' : 'static',
              right: contentAlignCenter ? '12px' : undefined,
              top: contentAlignCenter ? '12px' : undefined
            }}
          >
            <X size={20} color="#6b7280" />
          </button>
        </div>
        
        {/* Content */}
        <div style={{ padding: contentAlignCenter ? 0 : '24px', width: contentAlignCenter ? '100%' : undefined }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
